import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';
import { NON_CONFORMANCE_REPORTS_LOCAL_API_REQUESTS } from './utils/constants';

// GET projects/{projectId}/non-conformance-reports/unprocessed-count
// -> { projectId, count, bySubType: { nc, injury, close_call } }
export const getProjectUnprocessedNcCount = async (projectId) => {
  const apiPath = `projects/${projectId}/non-conformance-reports/unprocessed-count`;

  const signedRequest = await createSignedGetRequest({
    apiPath,
    isLocalApiRequest: NON_CONFORMANCE_REPORTS_LOCAL_API_REQUESTS,
  });

  const response = await axios(signedRequest);

  return response.data;
};
